import * as React from 'react';

import { LinkViewModel } from '../../Common/LinkViewModel.csharp';
import { withPromotionImpression } from '../../Tracking/GoogleTagManager/PromotionImpression/WithPromotionImpression';

interface LinkListItemProps {
    model: LinkViewModel;
}

function LinkListItem(props: LinkListItemProps) {
    const { text, target, href } = props.model;

    return (
        <a target={target} href={href}>
            <span>{text}</span>
        </a>
    );
}

export default withPromotionImpression(LinkListItem);
